import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Benefits() {
  const benefits = ['Bajar la ansiedad de abstinencia con técnicas rápidas (5 a 10 minutos).', 'Entender si estás en ansiedad, craving o pánico y aplicar lo correcto.', 'Identificar tus disparadores antes de que te arrastren.', 'Cortar el impulso con un método simple: Retrasar – Reducir – Redireccionar (3R).', 'Armar una rutina diaria antiansiedad (mañana/tarde/noche).', "Evitar el 'todo o nada' y tener un plan para recuperarte si recaíste.", 'Volver a conectar con tu propósito y valores (espiritualidad práctica).'];
  return <section className="py-24 md:py-32 px-6 bg-white" data-id="element-20">
      <div className="max-w-3xl mx-auto" data-id="element-21">
        <div className="text-center mb-14" data-id="element-22">
          <h2 className="text-3xl md:text-4xl font-serif text-[#2D2A26] mb-5" data-id="element-23">
            ¿Qué vas a lograr con esta guía?
          </h2>
          <p className="text-lg text-[#5D5A56]" data-id="element-24">
            Sin prometer milagros, este ebook te ayuda a:
          </p>
        </div>

        <div className="space-y-5" data-id="element-25">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="flex items-start gap-5 p-5 rounded-xl bg-[#FAF8F5]/50" data-id="element-26">
              <div className="w-7 h-7 rounded-full bg-[#7C8B6F] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-27">
                <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-28" />
              </div>
              <p className="text-[#3D3D3D] text-lg leading-relaxed" data-id="element-29">
                {benefit}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}